export const EVENT_LOAD = 'uv-sidebar-load';
export const EVENT_INFO = 'uv-sidebar-info';
export const EVENT_MINIMIZE = 'uv-sidebar-minimize';
export const EVENT_CLOSE = 'uv-sidebar-close';
export const EVENT_HOST_UNLOAD = 'uv-sidebar-host-unload';
